import React from 'react';

const Icon = ({ size = '47', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 47 47" fill="none" {...other}>
            <g clipPath="url(#a)" stroke="black" strokeLinecap="round">
                <path d="M6.146 28.733c0-6.808 5.519-12.327 12.327-12.327S30.8 21.926 30.8 28.733" strokeWidth="1.745" strokeLinejoin="round" />

                <path d="M6.259 28.733c0-6.808 5.519-12.327 12.327-12.327s12.327 5.52 12.327 12.327" strokeWidth="1.745" strokeLinejoin="round" />

                <path d="M15.995 28.096a2.908 2.908 0 0 1 5.817 0" strokeWidth="1.745" strokeLinejoin="round" />

                <path clipRule="evenodd" d="M34.127 31.49H2.908l1.653-2.23h27.086l2.48 2.23Z" strokeWidth="1.745" strokeLinejoin="round" />

                <path
                    d="m29.712 31.53-.961.278.52.827-.985.18.427.875-1 .08.332.913-1.004-.021.23.941-.996-.122.126.96-.977-.222.022.967-.948-.319-.083.964-.908-.413-.187.95-.858-.501-.29.926-.798-.585-.389.891-.73-.662-.484.848-.655-.733-.572.795-.572-.795-.655.733-.483-.848-.731.662-.388-.891-.8.585-.289-.926-.858.501-.188-.95-.908.413-.083-.964-.947.319.022-.967-.977.222.126-.96-.996.122.23-.941-1.003.02.331-.912-1-.08.427-.875-.986-.18.52-.827-.96-.279"
                    strokeWidth="1.163"
                />

                <path d="M30.537 25.188h7.27m-7.27 2.908h7.27" strokeWidth="1.745" strokeLinejoin="round" />

                <path
                    clipRule="evenodd"
                    d="M40.733 29.294H39.35c-.851 0-1.542-1.035-1.542-2.312v-9.894c0-1.277.69-2.313 1.542-2.313h1.384c.851 0 1.542 1.036 1.542 2.313v9.894c0 1.277-.69 2.312-1.542 2.312Z"
                    strokeWidth="1.745"
                    strokeLinejoin="round"
                />

                <path
                    d="M37.807 15.735c-3.87-3.004-8.942-5.31-13.963-6.49a2.047 2.047 0 0 0-2.282 1.06l-3.143 6.086"
                    strokeWidth="1.745"
                    strokeLinejoin="round"
                />

                <path
                    d="M37.808 20.097c-3.239-3.057-7.612-4.969-12.005-6.439l-1.675 3.35m-3.77 2.363a10.138 10.138 0 0 1 3.81 2.484"
                    strokeWidth="1.745"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M0 .467h46.532v46.532H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
